import VisitaBotox from "./visitabotox/index"
import AnamnesiBotox from "./anamnesibotox/index"

export default {
    VisitaBotox,
    AnamnesiBotox,
}